// Correction mapping for translation

var correct_translation = [
  { from: "Gwell", to: "Better" },
  { from: "GWELL", to: "BETTER" }
];

// ReciteMe robust loader logic
var reciteLoadedScripts = [];
var reciteEnableFragment = '#recite-enable'; // Change if you use a different fragment
var reciteAutoLoad = false; // Set to true if you want auto-load
var reciteOptions = {}; // Add any Recite.load options here

function reciteGetCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function reciteLoadScript(url, callback) {
  var script = document.createElement("script");
  script.type = "text/javascript";
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        if (typeof callback !== 'undefined') callback();
      }
    };
  } else {
    if (typeof callback !== 'undefined') {
      script.onload = function () { callback(); };
    }
  }
  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}

function reciteLoadService(serviceUrl, serviceKey, callback, shouldEnableToolbar = false) {
  var scriptId = serviceUrl + serviceKey;
  if (reciteLoadedScripts.includes(scriptId)) return;
  reciteLoadedScripts.push(scriptId);
  reciteLoadScript(serviceUrl + serviceKey, function () {
    if (typeof window._reciteLoaded === 'function') window._reciteLoaded();
    if (window.Recite && typeof window.Recite.load === 'function') {
      window.Recite.load(reciteOptions);
      if (window.Recite.Event && typeof window.Recite.Event.subscribe === 'function' && shouldEnableToolbar) {
        window.Recite.Event.subscribe("Recite:load", function () {
          window.Recite.enable();
        });
      }
    }
    if (typeof callback === 'function') callback();
  });
};


// Vanilla JS ReciteMe locale logic
export default () => {
  document.addEventListener('DOMContentLoaded', function () {
    var localeElements = document.querySelectorAll('[data-controller="locale"]');
    localeElements.forEach(function (element) {
      var serviceKey = element.getAttribute('data-locale-service-key-value');
      var serviceUrl = "//api.reciteme.com/asset/js?key=";
      var reciteLoading = false;
      var pendingLanguageHtml = null;
      var translationAccept = element.querySelector('[data-locale-target="translationAccept"]');
      var translationDecline = element.querySelector('[data-locale-target="translationDecline"]');
      var translationWarning = element.querySelector('[data-locale-target="translationWarning"]');
      var activeLanguage = element.querySelector('[data-locale-target="activeLanguage"]');
      var languageButtons = element.querySelectorAll('.languages__button [data-locale]');

      function storedLang() {
        return localStorage.getItem('user_lang');
      }

      // Nothing stored (or Recite syncing 'undefined') means the page is in
      // its served English. Recite itself stores the bare 'cy' code.
      function currentLang() {
        var lang = storedLang();
        return (lang && lang !== 'undefined') ? lang : 'en-GB';
      }

      function isWelsh(locale) {
        return /^cy/.test(locale || '');
      }

      function switchLanguage(locale, languageHtml) {
        handleTranslation(locale);
        pendingLanguageHtml = languageHtml;
        updateActiveLanguageDisplay();
      }

      function updateActiveLanguageDisplay() {
        if (activeLanguage && pendingLanguageHtml) {
          activeLanguage.innerHTML = pendingLanguageHtml;
          pendingLanguageHtml = null;
        }
      }

      function updateActiveLanguageDisplayForLocale(locale) {
        if (!activeLanguage || !locale) return;
        var languageButton = element.querySelector('[data-locale="' + locale + '"]');
        if (languageButton) {
          activeLanguage.innerHTML = languageButton.innerHTML;
        }
      }

      function handleTranslation(lang) {
        // Only change language, do not open toolbar if closed
        if (window.Recite && typeof window.Recite.Language?.Translate?.translate === 'function') {
          reciteLoading = false;
          localStorage.setItem('user_lang', lang);
          // Change language without opening toolbar
          window.Recite.Language.Translate.translate(document.body, lang);
          // Set preference if Recite is enabled, but do NOT enable if closed
          if (window.Recite.isEnabled?.()) {
            window.Recite.Preferences?.set?.('language', lang);
          }
        } else if (!reciteLoading) {
          reciteLoading = true;
          // Load ReciteMe script, but do NOT call enable here
          reciteLoadService(serviceUrl, serviceKey, function () {
            // After loading, just set language if Recite is loaded
            if (window.Recite && typeof window.Recite.Language?.Translate?.translate === 'function') {
              localStorage.setItem('user_lang', lang);
              window.Recite.Language.Translate.translate(document.body, lang);
              if (window.Recite.isEnabled?.()) {
                window.Recite.Preferences?.set?.('language', lang);
              }
            }
            reciteLoading = false;
          }, false);
        }
      }

      function syncLanguage() {
        var lang = Recite?.Preferences?.get?.('language');
        if (lang != storedLang()) {
          localStorage.setItem('user_lang', lang);
        }
        return lang;
      }

      function textNodesUnder(node) {
        var all = [];
        for (node = node.firstChild; node; node = node.nextSibling) {
          if (node.nodeType === 3) all.push(node);
          else all = all.concat(textNodesUnder(node));
        }
        return all;
      }

      function reciteLoaded() {
        if (!window.Recite?.Event?.subscribe) return;
        [
          'Preferences:load',
          'Preferences:set',
          'Preferences:reset'
        ].forEach(event => window.Recite.Event.subscribe(event, syncLanguage));
        window.Recite.Event.subscribe('Recite:disable', resetLang);
        // Apply corrections after translation completes
        window.Recite.Event.subscribe('Translate:complete', function () {
          var lang = localStorage.getItem('user_lang');
          if (lang === 'cy') {
            var bodyNode = document.body;
            var elements = textNodesUnder(bodyNode);
            elements.forEach(node => {
              correct_translation.forEach(pair => {
                node.textContent = node.textContent.replace(new RegExp(pair.from, 'g'), pair.to);
              });
            });
          }
        });
      }

      function resetLang() {
        var launchLang = localStorage.getItem('launch_language');
        if (launchLang ?? false) {
          localStorage.setItem('user_lang', launchLang);
        } else {
          localStorage.removeItem('user_lang');
        }
      }

      // Event listeners
      if (translationAccept) {
        translationAccept.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var locale = translationAccept.dataset.locale;
          handleTranslation(locale);
          updateActiveLanguageDisplay();
          if (translationWarning) translationWarning.style.display = 'none';
        });
      }

      if (translationDecline) {
        translationDecline.addEventListener('click', function (event) {
          event.preventDefault();
          if (translationWarning) translationWarning.style.display = 'none';
        });
      }

      // The disclaimer only guards the move INTO Welsh: switching back to
      // English is silent, and re-picking the current language is a no-op.
      languageButtons.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var locale = btn.dataset.locale;
          if (isWelsh(locale) === isWelsh(currentLang())) return;
          if (!isWelsh(locale)) return switchLanguage(locale, btn.innerHTML);
          if (translationWarning) translationWarning.style.display = 'flex';
          if (translationAccept) translationAccept.dataset.locale = locale;
          pendingLanguageHtml = btn.innerHTML;
        });
      });

      // Robust ReciteMe loader for the accessibility bar
      function loadService(callback) {
        // Prevent scroll jump by saving and restoring scroll position after ReciteMe manipulates DOM
        const scrollY = window.scrollY;
        const scrollX = window.scrollX;
        function restoreScroll() {
          setTimeout(() => {
            window.scrollTo(scrollX, scrollY);
          }, 400);
        }
        // Only open toolbar if not already enabled
        if (window.Recite && typeof window.Recite.enable === 'function') {
          if (!window.Recite.isEnabled?.()) {
            window.Recite.enable();
            restoreScroll();
          }
          if (typeof callback === 'function') callback();
        } else {
          reciteLoadService(serviceUrl, serviceKey, function () {
            reciteLoaded();
            // After loading, enable only if not already enabled
            if (window.Recite && typeof window.Recite.enable === 'function' && !window.Recite.isEnabled?.()) {
              window.Recite.enable();
              restoreScroll();
            }
            if (typeof callback === 'function') callback();
          }, true);
        }
      }

      // Make loadService globally accessible for inline onclick handlers
      window.loadService = loadService;

      // Initial load if Recite.Persist cookie is set or via hash/autoLoad
      var persist = reciteGetCookie('Recite.Persist');
      var hashMatch = window.location.hash === reciteEnableFragment;
      if (persist === 'true') {
        reciteLoadService(serviceUrl, serviceKey, reciteLoaded, false);
      }
      if ((reciteAutoLoad && persist !== 'false') || hashMatch) {
        reciteLoadService(serviceUrl, serviceKey, reciteLoaded, false);
      }

      // Language sync on load
      if (
        persist === 'false' ||
        persist === null ||
        persist == 'null'
      ) {
        if ((storedLang() != 'undefined') && (storedLang() != null)) {
          handleTranslation(storedLang());
          updateActiveLanguageDisplayForLocale(storedLang());
        }
      }
    });
  });
}